export function createRouteContextRegistry() {
  const contexts = new Map()
  const manualSubscribedTopics = new Set()
  const manualGeneralHandlers = []

  function compute() {
    const allPatterns = []
    const allHandlers = [...manualGeneralHandlers]
    const allTopics = new Set(manualSubscribedTopics)

    for (const context of contexts.values()) {
      for (const pattern of normalizePatterns(context.clientPatterns)) {
        allPatterns.push(pattern)
      }
      if (typeof context.onGeneralMessage === 'function') {
        allHandlers.push(context.onGeneralMessage)
      }
      for (const topic of context.subscriptions || []) {
        if (topic) {
          allTopics.add(topic)
        }
      }
    }

    return {
      clientPatterns: normalizePatterns(allPatterns),
      contextCount: contexts.size,
      generalHandlers: allHandlers,
      subscribedTopics: allTopics,
    }
  }

  return {
    addManualGeneralHandler(handler) {
      if (typeof handler !== 'function') return false
      if (manualGeneralHandlers.includes(handler)) return false
      manualGeneralHandlers.push(handler)
      return true
    },
    addManualTopic(topic) {
      if (!topic || manualSubscribedTopics.has(topic)) return false
      manualSubscribedTopics.add(topic)
      return true
    },
    clearManualTopics() {
      manualSubscribedTopics.clear()
    },
    compute,
    registerContext({
      clientPatterns = [],
      contextId,
      onGeneralMessage,
      subscriptions = [],
    }) {
      if (!contextId) return false

      contexts.set(contextId, {
        clientPatterns: Array.isArray(clientPatterns) ? clientPatterns : [],
        onGeneralMessage:
          typeof onGeneralMessage === 'function' ? onGeneralMessage : null,
        subscriptions: new Set(
          Array.isArray(subscriptions) ? subscriptions : []
        ),
      })
      return true
    },
    removeContext(contextId) {
      if (!contextId) return false
      return contexts.delete(contextId)
    },
    removeManualGeneralHandler(handler) {
      const index = manualGeneralHandlers.indexOf(handler)
      if (index === -1) return false
      manualGeneralHandlers.splice(index, 1)
      return true
    },
    removeManualTopic(topic) {
      if (!topic) return false
      return manualSubscribedTopics.delete(topic)
    },
    reset() {
      contexts.clear()
      manualSubscribedTopics.clear()
      manualGeneralHandlers.splice(0, manualGeneralHandlers.length)
    },
  }
}

function normalizePatterns(clientPatterns = []) {
  const patterns = []
  const seen = new Set()

  for (const pattern of clientPatterns) {
    if (!pattern || typeof pattern !== 'object') continue
    const prefix = String(pattern.prefix || '')
    const clientIndex = Number(pattern.clientIndex)
    if (!prefix || !Number.isFinite(clientIndex)) continue

    const key = `${prefix}::${clientIndex}`
    if (seen.has(key)) continue
    seen.add(key)
    patterns.push({ clientIndex, prefix })
  }

  return patterns
}
